var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlowioIkona(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5",
    "data-name": "Group 5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 214.95,
    height: 263.842,
    viewBox: "0 0 214.95 263.842",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#002f61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.212,
    stopColor: "#003164"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#00376e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    stopColor: "#00417f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#005098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791,
    stopColor: "#005aa8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.797,
    y1: 0.742,
    x2: -0.025,
    y2: 0.073,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004794"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.972,
    y1: -0.12,
    x2: -0.396,
    y2: 1.364,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.921,
    y1: 0.791,
    x2: 0.115,
    y2: 0.25,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1.337,
    y1: -0.823,
    x2: 0.081,
    y2: 0.949,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.266,
    y1: 1.585,
    x2: 0.63,
    y2: -0.359,
    xlinkHref: "#linear-gradient-2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M174.675,345.937c0,45.186,112.114,66.114,144,13.138l27.574-56.54c-9.042,18.536-148.368,78.765-171.393-34.824l-.18,43.552Z",
    transform: "translate(-174.675 -199.31)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M277.157,300.128h53.606c34.423,0,58.862-43.1,58.862-64.643H272.952c-51.161,0-98.277,26.425-98.277,73.384v73.244C181.507,329.9,225.993,300.128,277.157,300.128Z",
    transform: "translate(-174.675 -235.485)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M175.67,320.333v40.432c14.009-42.036,54.857-65.342,100.37-65.342h53.606a40.353,40.353,0,0,0,13.692-2.437c8.955-3.218,16.757-9.3,23.078-16.314a86.773,86.773,0,0,0,14.707-22.84,64.485,64.485,0,0,0,4.89-16.04,83.308,83.308,0,0,1-6.983,8.923c-6.323,7.015-14.125,13.1-23.078,16.314a40.305,40.305,0,0,1-13.695,2.437c-17.867,0-53.08,1.051-70.949,1.051C230.142,266.517,192.794,285.586,175.67,320.333Z",
    transform: "translate(-173.558 -232.894)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M271.9,344.944h33.012c2.719,0,12.62.607,7.964,7.9,1.936-2.314,4.525-5.285,5.8-7.9l27.419-56.209c3.869-7.934-5.771-8.435-9.222-8.435H267.7c-51.161,0-93.022,41.86-93.022,93.024v75.7c20.145,0,52.042-24.057,52.042-49.966C226.717,373.963,219.176,344.944,271.9,344.944Z",
    transform: "translate(-174.675 -185.178)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-4)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M313.98,327.986a16.921,16.921,0,0,0,1.176-2l14.049-28.8c-18.156-.255-52.721-.964-61.761-.964a109.107,109.107,0,0,0-15.206.945l-.006-.032-2.471.395c-30.184,4.82-58.1,17.161-72.289,40.829a90.022,90.022,0,0,0-1.636,17.088v21.038c11.795-30.1,42.994-45.131,77.079-50.575l2.471-.4,0,.032a109.117,109.117,0,0,1,15.208-.942h33.012a23.162,23.162,0,0,1,5.325.594A9.371,9.371,0,0,1,313.98,327.986Z",
    transform: "translate(-173.372 -167.303)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-5)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M175.6,403.884c7.335-.543,15.193-4.016,22-8.435,3.343-10.239,2.439-25.235,1.125-44.416-1.31-19.111,13.015-32.247,13.121-32.345-21.353,11.761-36.244,30.957-36.244,60.638Z",
    transform: "translate(-173.633 -142.088)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-6)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M228.5,330.647c3.048-9.016,10.139-16.112,26.1-18.941-23.664,3.78-78.712,17.294-79.923,73.473.548-8.507,6.164-35.58,53.814-54.53l0,0Zm30.136-19.542.023,0v0Z",
    transform: "translate(-174.666 -150.605)",
    fillRule: "evenodd",
    opacity: 0.4,
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowioIkona);
export default __webpack_public_path__ + "static/media/flowio-ikona.8a38f79e0a0b3afa173b2a458e570fe2.svg";
export { ForwardRef as ReactComponent };